import { Box, BoxProps, CircularProgress, CircularProgressProps } from '@mui/material'
import { FC } from 'react'

interface FullWidthLoadingFallbackProps extends BoxProps {
  color?: CircularProgressProps['color']
}

export const FullWidthLoadingFallback: FC<FullWidthLoadingFallbackProps> = ({ sx, color = 'secondary', ...props }) => (
  <Box
    {...props}
    sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 4,
      ...sx,
    }}
  >
    <CircularProgress color={color} />
  </Box>
)

interface IconLoadingFallbackProps {
  size?: number
}

export const IconLoadingFallback: FC<IconLoadingFallbackProps> = ({ size = 20 }) => (
  <CircularProgress color="secondary" size={size} />
)
